<template lang="html">
    <v-card v-if="chapterAwards.length">
        <v-layout row wrap class="chapter_awards">
            <v-flex class="chapter_awards__header">
                <span data-qe-id="chapter-awards-header-text">{{ regionHeader }}</span>
                <img src="../../../assets/Awards.png" />
            </v-flex>
            <v-flex class="chapter_awards__details inner-scrollbar">
                <v-flex class="chapter_awards__details__row" v-for="(chapterAward, i) in chapterAwards" :key="i">
                    <v-flex tag="h3" :data-qe-id="`chapter-award_${i}_year`">
                        {{ chapterAward.year }} {{ communityCommonConstant.chapter_awards.Winners }}
                    </v-flex>
                    <v-flex tag="h4"> {{ communityCommonConstant.chapter_awards.Best_Of_Best }}</v-flex>
                    <v-flex v-for="(awardcategory, j) in chapterAward.awards" :key="j">
                        <v-layout row wrap class="chapter_awards__details__desc">
                            <v-avatar class="text-md-center">
                                <img
                                    :src="awardcategory.profileImageUrl"
                                    :onerror="imageErrorFallback(awardcategory.fallbackProfileImageUrl)"
                                />
                            </v-avatar>
                            <span>
                                <strong :data-qe-id="`award-category_${i}_name`">{{ awardcategory.name }} </strong>
                                <em>{{ awardcategory.personName }}</em>
                            </span>
                        </v-layout>
                        <v-divider></v-divider>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { communityCommonConstant } from '../communityCommon.constant';
import { storeAction } from '../../../store/storeActions.constant';
import { storeGetters } from '../../../store/storeGetters.constant';
import { capitalizedString, imageErrorFallback } from '../../../common/utils/utils';

export default {
    name: 'ChapterAwards',
    props: {
        currentCommunityId: {
            type: String,
        },
    },
    created() {
        this.getChapterAwards(this.currentCommunityId);
        this.$watch(
            () => this.$store.getters[storeGetters.communityIdPromise],
            () => {
                this.getChapterAwards();
            },
        );
    },
    data: () => {
        return {
            communityCommonConstant,
        };
    },
    methods: {
        ...mapActions({
            getChapterAwards: `chapter/${storeAction.getChapterAwards}`,
        }),
        imageErrorFallback,
    },
    computed: {
        ...mapGetters({
            chapterAwards: `chapter/${storeGetters.chapterAwards}`,
        }),
        regionHeader() {
            return `${capitalizedString(this.$store.getters[storeGetters.communityName])} ${
                communityCommonConstant.chapter_awards.Title_Header
            }`;
        },
    },
};
</script>

<style lang="scss">
@import '../../../common/styles/_colors.scss';

.chapter_awards {
    &__header {
        min-height: 70px;
        max-width: 100%;
        background-color: $ypo-blue;
        color: $ypo-gold;
        font-family: Raleway;
        padding: 5px 15px;
        line-height: 60px;
        font-size: 24px;
        letter-spacing: 0.2px;
        border-radius: 4px 4px 0 0;

        img {
            position: absolute;
            right: 0;
            top: 0;
            max-width: 84px;
        }
    }

    &__year {
        max-height: 50px;
        min-width: 100%;
        font-family: Raleway;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 0.16px;
        line-height: 26px;
        color: $ypo_blue;
    }

    &__best {
        background-color: $white;
        font-family: Raleway, serif;
        color: $ypo_blue;

        h2 {
            background: rgba($ypo-title-blue-gray, 0.3);
            padding: 5px 15px;
        }
    }

    &__details {
        min-height: 350px;
        max-height: 350px;
        overflow-y: auto;

        h6 {
            color: $ypo_blue;
            font-size: 16px;
            border-bottom: 3px solid $ypo_blue;
            margin: 25px 15px 15px 15px;
            font-weight: 600;
        }

        h4 {
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 0.15px;
            line-height: 30px;
            background-color: $ypo-light-gray-background;
            color: $ypo-blue;
            padding-left: 15px;
            margin-bottom: 35px;
        }

        h3 {
            opacity: 0.5;
            font-size: 22px;
            padding: 7px 15px;
            color: rgba(84, 110, 122, 0.9);
            font-weight: 600;
            letter-spacing: 0.16px;
            line-height: 26px;
        }

        &__desc {
            position: relative;
            margin-bottom: 10px;

            .v-avatar {
                position: absolute;

                left: 20px;
                top: -4px;
                z-index: 1;
                border: 1px solid $ypo-blue;
            }

            span {
                color: $white;
                font-size: 12px;
                position: relative;
                min-height: 14px;
                display: block;
                width: 100%;
                padding: 0 15px 0 15px;

                strong {
                    font-weight: 400;
                    min-height: 35px;
                    display: block;
                    background: $ypo-blue;
                    padding-left: 60px;
                    border-radius: 3px;
                    padding: 3px 0 3px 60px;
                }

                em {
                    display: block;
                    color: $ypo-blue;
                    font-style: normal;
                    font-weight: 600;
                    margin-top: 5px;
                    padding-left: 60px;
                }
            }
        }
    }

    .v-divider {
        margin: 0 15px 15px 15px;
        border-width: 1px;
    }
}
</style>
